// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__10dw9","pageWrap":"App_pageWrap__24FLN"};